import { campaign, routes } from '../../constants';

export interface PromoCampaign {
  id: string;
  headlineKey: string;
  bodyKey: string;
  ctaKey: string;
  ctaRoute: string;
  /** Amplitude `campaign` name for the MessageDisplayed impression event. */
  trackingCampaign: string;
}

// Keyed by campaign id. Add an entry per campaign; the active one is chosen by the container.
const campaigns: Record<string, PromoCampaign> = {
  'podcast-launch': {
    id: 'podcast-launch',
    // Copy shared with the MUKI podcast template infoBanner (formConfigs.ts).
    headlineKey: 'New: Podcasts (Beta)',
    bodyKey: 'Just launched. Various podcast formats, uploading your own materials,'
      + ' further editing in chat, and more are coming soon.',
    ctaKey: 'Create podcast',
    ctaRoute: `/${routes.aiTools.root}`,
    trackingCampaign: campaign.dashboardPodcastPromo,
  },
};

export const getPromoCampaign = (variant?: string): PromoCampaign | undefined =>
  variant ? campaigns[variant] : undefined;
